(function () {
  'use strict';

  /* @ngdoc object
   * @name auditReport
   * @description
   *
   */
  angular
    .module('userActivityAuditReport', [
      'ui.router'
    ]);
}());
